"use strict";
/// <reference path="../../../Trillium.UI/TypeScript/Models/Website/ListFoldersViewModel.tsx"/>
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var ListFolders = /** @class */ (function (_super) {
    __extends(ListFolders, _super);
    function ListFolders(props) {
        var _this = _super.call(this, props) || this;
        _this.gointoFolder = function (foldername) {
            _this.props.onFolderclick(foldername);
        };
        _this.gointoFolder = _this.gointoFolder.bind(_this);
        return _this;
    }
    ListFolders.prototype.render = function () {
        var _this = this;
        return (react_1.default.createElement("div", { className: "card" },
            react_1.default.createElement("div", { className: "card-body" },
                this.props.HeaderText ? react_1.default.createElement("h2", { className: "card-title" }, this.props.HeaderText) : null,
                react_1.default.createElement("div", { className: "document-grid" }, this.props.Folders.length ? (this.props.Folders.map(function (folder) {
                    return react_1.default.createElement("div", { className: "m-2 card document-grid-item cp", key: folder.Id, id: folder.Id, onClick: function () { return _this.gointoFolder(folder); }, style: _this.props.selectFolder === folder.Id ? { backgroundColor: 'cadetblue' } : {} },
                        react_1.default.createElement("div", { className: "ipd-document-library-item d-flex flex-column card-body d-md-flex justify-content-md-between align-items-center" },
                            react_1.default.createElement("i", { className: "fas fa-folder" }),
                            react_1.default.createElement("div", { className: "font-bold item-count" }, folder.CountOfItems),
                            react_1.default.createElement("div", { className: "text-center font-bold m-auto" }, folder.Name)));
                })) : null))));
    };
    return ListFolders;
}(react_1.default.Component));
exports.default = ListFolders;
